import { createRootRoute, Outlet } from '@tanstack/react-router';
import { QueryProvider } from '@/lib/query';

export const rootRoute = createRootRoute({
  component: RootLayout,
});

// 後方互換性のため
export const Route = rootRoute;

function RootLayout() {
  return (
    <QueryProvider>
      <div data-testid="root-layout">
        <Outlet />
      </div>
    </QueryProvider>
  );
}
